import "react-multi-carousel/lib/styles.css";

import React, { Component } from "react";
import { Helmet } from "react-helmet";
import { BiFlag } from "react-icons/bi";
import { BsFillClockFill } from "react-icons/bs";
import { FiChevronRight, FiChevronLeft, FiShare2 } from "react-icons/fi";
import { HiLocationMarker } from "react-icons/hi";
import Carousel from "react-multi-carousel";
import { Link, Redirect } from "react-router-dom";
import { RWebShare } from "react-web-share";

import ConnectionsModal from "../../../base/features/blocks/ConnectionsModal";
import ReportModal from "../../../base/features/blocks/ReportModal";
import AddToCartBtn from "../../../base/features/micro/AddToCartBtn";
import checkLength from "../../../base/utils/check_length";
import convert_to_object from "../../../base/utils/convert_to_object";
import { navigate_to_shop } from "../../../navigator/user/shop";
import {
  getProductId,
  getShopUid,
  isSiteDomain,
} from "../../../settings/domainManager";
import Comment from "../comment/Comment";
import SameProductsBlock from "./blocks/SameProductsBlock";
import { product, productComments } from "./services";
import Image from "../../../base/features/micro/Image";

class Product extends Component {
  constructor(props) {
    super(props);
    this.state = {
      product: null,
      comments: null,
      redirect: false,
      acceptReportModal: false,
      selected_shop:
        localStorage.getItem("selected_shop") &&
        JSON.parse(localStorage.getItem("selected_shop")),
      isManager:
        window.location.search &&
        convert_to_object.fixObject(window.location.search).isManager &&
        true,
      product_id: getProductId(),
      shop_uid: getShopUid(),
      responsive: {
        superLargeDesktop: {
          breakpoint: { max: 4000, min: 3000 },
          items: 5,
        },
        desktop: {
          breakpoint: { max: 3000, min: 1024 },
          items: 3,
        },
        tablet: {
          breakpoint: { max: 1024, min: 464 },
          items: 2,
        },
        mobile: {
          breakpoint: { max: 464, min: 0 },
          items: 1,
        },
      },
      phoneDetail: false,
    };
  }

  componentDidMount() {
    this.get_products();
    this.get_comments();
  }
  componentDidUpdate(prv_props, prv_state) {
    if (
      this.state.shop_uid !== getShopUid() ||
      this.state.product_id !== getProductId()
    ) {
      this.setState(
        {
          shop_uid: getShopUid(),
          product_id: getProductId(),
          comments: null,
          product: null,
        },
        () => {
          this.get_products();
          this.get_comments();
        }
      );
    }
  }
  get_products() {
    product(this.state.product_id, window.location.search).then((items) => {
      if (items) {
        this.setState({ product: items });
      }
    });
  }
  get_comments() {
    productComments(this.state.product_id).then((items) => {
      items && this.setState({ comments: items.results });
    });
  }
  render() {
    if (this.state.redirect) {
      return <Redirect push to={navigate_to_shop(this.state.shop_uid)} />;
    }
    console.log(this?.state?.phoneDetail);
    return (
      <div className="container-fluid px-0">
        {this.state.product && this.state.acceptReportModal && (
          <ReportModal
            uId={this.state.product.id}
            acceptReportModal={this.state.acceptReportModal}
            modalChange={(value) => this.setState({ acceptReportModal: value })}
            type={"product"}
          />
        )}
        <header
          className="row mx-0 px-3 py-2-3 position-fixed bg-white shadow-sm"
          style={{ top: "0", right: "0", left: "0", zIndex: "4" }}
        >
          <div
            className="col align-self-center px-0"
            onClick={() =>
              window.history.length > 1
                ? window.history.back()
                : this.setState({ redirect: true })
            }
          >
            <FiChevronRight size="30" />
            <span className="fw fs-5 me-2 align-bottom">
              {this.state.product && checkLength(this.state.product.name, 21)}
            </span>
          </div>
          <div className="col-auto align-self-center px-3">
            <RWebShare
              data={{
                // text: this.state.shop_uid,
                url: window.location.href,
                title: "Gity market",
              }}
              onClick={() => console.log("shared successfully!")}
            >
              <FiShare2 size={24} />
            </RWebShare>
          </div>
          {!isSiteDomain && (
            <div className="col-auto align-self-center px-0">
              <BiFlag
                onClick={() => this.setState({ acceptReportModal: true })}
                size={24}
              />
            </div>
          )}
        </header>
        <body style={{ marginTop: "56px", marginBottom: "80px" }}>
          {this.state.product && (
            <section>
              <Helmet>
                <meta charSet="utf-8" />
                <title>{`${this.state.product.name} | ${this.state.product.shop.title}`}</title>
                <meta
                  name="description"
                  key="description"
                  content={`${this.state.product.name} | ${this.state.product.shop.title}`}
                />
                <meta
                  property="twitter:card"
                  key="twitter:card"
                  content="summary"
                />
                <meta
                  property="twitter:creator"
                  key="twitter:creator"
                  content="@gitymarket"
                />
                <meta
                  property="twitter:title"
                  key="twitter:title"
                  content={`${this.state.product.name} | ${this.state.product.shop.title}`}
                />
                <meta
                  property="twitter:description"
                  key="twitter:description"
                  content={`${this.state.product.name} | ${this.state.product.shop.title}`}
                />
                <meta
                  property="og:title"
                  key="og:title"
                  content={`${this.state.product.name} | ${this.state.product.shop.title}`}
                />
                <meta
                  property="og:description"
                  key="og:description"
                  content={`${this.state.product.name} | ${this.state.product.shop.title}`}
                />
                <meta
                  property="og:url"
                  key="og:url"
                  content={window.location.href}
                />
                <meta property="og:type" key="og:type" content="website" />
                <meta
                  property="og:image"
                  key="og:image"
                  content={`${this.state.product.image.file}`}
                />
                <link rel="canonical" href={window.location.href} />
              </Helmet>
              <div className="row mx-0">
                <div
                  className="col-12 px-0"
                  style={{ height: "50vh" }}
                  dir="ltr"
                >
                  <Carousel
                    className="h-100"
                    autoPlay={false}
                    responsive={this.state.responsive}
                    showDots={true}
                    infinite={true}
                    draggable={true}
                    swipeable={true}
                    keyBoardControl={true}
                    arrows={false}
                    sliderClass="h-100"
                    containerClass="carousel-container"
                    dotListClass="custom-dot-list-style"
                  >
                    {this.state.product.medias.map((media, m) => (
                      <img
                        src={media.file}
                        alt={this.state.product.name}
                        className="w-100 h-100 img-cover"
                      />
                    ))}
                  </Carousel>
                </div>
              </div>
              <div className="row mx-0 p-4">
                <div className="col-12 px-0">
                  <div className="mb-2">
                    <HiLocationMarker className="text-dark-green" size={17} />
                    <Link
                      to={navigate_to_shop(
                        product.shop ? product.shop.uid : this.state.shop_uid
                      )}
                    >
                      <span className="me-1 fs-7 text-dark-green">
                        {this.state.product.shop.title}
                      </span>
                    </Link>
                  </div>
                  {this.state.product.preparation_time && (
                    <div>
                      <BsFillClockFill className="text-dark-green" size={14} />
                      <span className="me-1 fs-7 text-dark-green">
                        مدت زمان آماده سازی:{" "}
                        {this.state.product.preparation_time}
                      </span>
                    </div>
                  )}
                  <h1 className="fs-2 mt-3 fw-bolder">
                    {this.state.product.name}
                  </h1>
                  {this.state?.product?.shop && (
                    <div className="row mx-0 p-2 rounded14 my-3 shadow-2">
                      <div className="col-2 mx-0 align-self-center">
                        <Image
                          imageHeight={"45"}
                          imageWidth={"45"}
                          extraClassName={"p-0 img-contain"}
                          imgClassName={"rounded-circle img-cover"}
                          isProfile={true}
                          imageUri={
                            this.state?.product?.shop?.conver?.thumbnail
                          }
                        />
                      </div>
                      <div className="col-7 px-1">
                        <div className="col px-1 align-self-center">
                          <p className="fw-bolder mb-0 fs-6">
                            {this.state?.product?.shop?.title}
                          </p>
                        </div>
                        <div className="col px-1 mt-2 align-self-center">
                          <p className="text-gray mb-0 fs-7">
                            {this.state?.product?.shop?.sub_title}
                          </p>
                        </div>
                      </div>
                      <div className="col-1 align-self-center color-main">
                        <div
                          className="d-flex align-self-center"
                          onClick={() => this.setState({ phoneDetail: true })}
                        >
                          <span>تماس</span>
                          <span>
                            <FiChevronLeft size={24} />
                          </span>
                        </div>
                      </div>
                      {/* <div className="col-12 fw-bolder fs-4 p-3 border-bottom">
                      <div className="row mx-0 px-0">
                        <div className="col-auto px-1 align-self-center">
                          <p className="fw-bold mb-0 fs-6">
                            22
                            <span className="me-1">سفارش</span>
                          </p>
                        </div>
                      </div>
                    </div> */}
                      {/* <div className="col-12 fw-bolder fs-4 p-3">
                      <div className="row mx-0 px-0">
                        <div className="col-auto align-self-center px-1">
                          <button className="btn px-3 rounded28 border color-main fw-bold fs-6">
                            نمایش اطلاعات
                          </button>
                        </div>
                        <div className="col px-1">
                          <p className="fs-7 text-muted mb-1" dir="ltr">
                            جمع کل
                          </p>
                          <p className="fs-5 text-start mb-0">
                            <span>321</span>
                            <span className="fs-7 me-1">123</span>
                          </p>
                        </div>
                      </div>
                    </div> */}
                    </div>
                  )}
                  <p className="my-3" style={{ whiteSpace: "break-spaces" }}>
                    {this.state.product.des}
                  </p>
                </div>

                {this.state.product?.shop?.services?.review && (
                  <div className="col-12 px-0 mt-3">
                    <h2 className="fs-5 fw-bolder mb-3">نظرات</h2>
                    <Link to={`./${this.state.product_id}/add-comment`}>
                      <button className="btn py-2 w-100 rounded28 text-white bg-color-main">
                        افزودن نظر جدید
                      </button>
                    </Link>
                  </div>
                )}
              </div>
            </section>
          )}
          {this.state.product?.shop?.services?.review &&
            this.state.comments &&
            this.state.comments.map((comment, c) => (
              <Comment
                comment={comment}
                key={c}
                get_comments={() => this.get_comments()}
              />
            ))}
          {this.state.product && (
            <section>
              {this.state.product.same_products &&
                this.state.product.same_products.length !== 0 && (
                  <SameProductsBlock
                    title={"محصولات مشابه"}
                    products={this.state.product.same_products}
                  />
                )}
              {this.state.product.other_products &&
                this.state.product.other_products.length !== 0 && (
                  <SameProductsBlock
                    title={"سایر محصولات"}
                    products={this.state.product.other_products}
                  />
                )}
            </section>
          )}
          {this.state.phoneDetail && (
            <ConnectionsModal
              phone={this.state.product?.shop?.call_center}
              connectionsModalChange={(value) =>
                this.setState({ phoneDetail: value })
              }
              connectionsModal={this.state.phoneDetail}
              withoutOnlineOrdering={true}
              shop={this.state.product?.shop}
            />
          )}
        </body>
        {this.state.product && (
          <footer
            className="row py-2 px-3 mx-0 position-fixed bg-white shadow-sm"
            style={{ bottom: "0", left: "0", right: "0", zIndex: "4" }}
          >
            <div className="col align-self-center px-0">
              {this.state.isManager && this.state.selected_shop ? (
                <Link
                  to={`/dashboard/${this.state.shop_uid}/p/${this.state.product_id}`}
                >
                  <button className="btn rounded28 px-3 py-2 bg-color-main text-white fw-bold">
                    ویرایش محصول
                  </button>
                </Link>
              ) : (
                this.state.product.has_stock && (
                  <AddToCartBtn
                    product={this.state.product}
                    shopUid={this.state.product.shop.uid}
                    onlineOrdering={
                      this.state?.product?.shop?.services?.online_ordering
                    }
                    btnType={"product"}
                    clickPhoneDetail={() =>
                      this.setState({ phoneDetail: true })
                    }
                  />
                )
              )}
            </div>
            <div className="col-auto text-start">
              {this.state.product.has_stock && (
                <p className="fs-7 text-muted mb-0">قیمت</p>
              )}
              {this.state.product.discount && (
                <p
                  className="fs-7 fw-bold mb-0 text-muted"
                  style={{ textDecoration: "line-through" }}
                >
                  <span>{this.state.product.price.title}</span>
                  <span className="me-1">
                    {this.state.product.price.currency}
                  </span>
                </p>
              )}
              {this.state.product.payable_price && (
                <p className="fs-5 fw-bolder mb-0">
                  <span
                    style={{ color: this.state.product.payable_price.color }}
                  >
                    {this.state.product.payable_price.title}
                  </span>
                  <span className="fs-7 me-1">
                    {this.state.product.payable_price.currency}
                  </span>
                </p>
              )}
            </div>
          </footer>
        )}
      </div>
    );
  }
}

export default Product;
